<div
  *ngIf="inkasso?.beitragszahler?.value?.id && currentKundeID && inkasso.beitragszahler.value.id !== currentKundeID">
  <div class="infobox">
    <div class="infoicon">
      <mat-icon color="gray">info_outline</mat-icon>
    </div>
    <div class="infomessage blue-text">Es handelt sich hierbei um ein abweichendes Inkasso</div>
  </div>
</div>
<div class="inkasso-container">
  <app-dynamic-form [data]="inkasso" [descriptorMap]="description">
  </app-dynamic-form>
</div>
